export const API_URL = `${process.env.REACT_APP_REST_API_HOST}`;
export const API_URL_SUBSCRIPTION = `${process.env.REACT_APP_REST_API_SUBSCRIPTION}`;
export const APPOINTMENT_URL = `${process.env.REACT_APP_APPOINTMENT_URL}`;
export const APPOINTMENT_PATENTE_URL = `${process.env.REACT_APP_APPOINTMENT_PATENTE_URL}`;

export const JWT_TOKEN = "cos-milano-web-token";
export const USER_FULL_NAME = "cos-milano-web-fullName";
export const USER_ID = "cos-milano-client-id";
export const USER_PHOTO = "cos-milano-client-photo";
export const ENFORCE_STATUS = "cos-milano-enforce";
export const USER_DATA = `cos-milano-web-user`;
